import React from "react";
import { useLoaderData } from "react-router";
import TwoColumnLayout from "layout/TwoColumnLayout";
import MakeCreditEditSection from "invoice/makecredit/MakeCreditEditSection";
import GeneralOptionsPanel from "components/optionspanel/GeneralOptionsPanel";

export const MakeCreditApp = () => {
  const viewModel = useLoaderData<server.viewmodel.InvoiceV1MakeCreditFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <MakeCreditEditSection viewModel={viewModel} />
    </TwoColumnLayout.LeftColumn>
    <TwoColumnLayout.RightColumn>
      <GeneralOptionsPanel
        data={viewModel.optionsPanel}
        links={[{ text: RESX.Buttons.ListView, visible: true, href: viewModel.listUrl }]}
      />
    </TwoColumnLayout.RightColumn>
  </TwoColumnLayout>
};

export default MakeCreditApp;

